import { Component, OnInit } from '@angular/core'
import { Meta, Title } from '@angular/platform-browser'
import { ActivatedRoute } from '@angular/router'
import { NgbModal, NgbModalOptions  } from '@ng-bootstrap/ng-bootstrap'
import { ContentService } from 'src/app/services/content/content.service'

@Component({
	selector: 'app-b2b',
	templateUrl: './b2b.component.html',
	styleUrls: ['./b2b.component.scss'],
})
export class B2bComponent implements OnInit {
	constructor(
		private content: ContentService,
		private route: ActivatedRoute,
		private modal: NgbModal,
		private meta: Meta,
		private title: Title,
	) {}
	lang: string = ''
	iceFormTitle: string = ''
	inputName: string = ''
	inputEmail: string = ''
	inputCnpj: string = ''
	inputPhone: string = ''
	inputCep: string = ''
	inputTerms: string = ''
	inputSend: string = ''
	modalSuccessTitle: string = ''
	modalSuccessText: string = ''
	modalErrorTitle: string = ''
	modalErrorText: string = ''
	resellerModalButton: string = ''
	onlyNumbersPlaceHolder: string = ''
	data: any
	dataProduct: any
	dataPurifiers: any

    dictionary: any = {
        production: '',
        size: '',
        voltage: '',
        power: '',
        frequency: '',
        stainlessSteel: '',
        refrigerantGas: '',
        dimensions: '',
    }


	ngOnInit(): void {
		this.lang = this.route.snapshot.params.lang
		const slug = this.route.snapshot.paramMap.get('slug');
		const self = this
		this.content.getPage(
			`pages/?type=cms.B2b&fields=*&`,
  			this.lang,
			{
				fnSuccess: (data) => {
					self.title.setTitle(data.items[0].meta.seo_title || 'B2B')
					self.meta.updateTag({
						property: 'og:description',
						content: data.items[0].meta.search_description,
					})
					self.meta.updateTag({
						property: 'og:title',
						content: data.items[0].meta.seo_title,
					})
					self.meta.updateTag({
						property: 'og:url',
						content: window.location.href,
					})
					self.data = data.items[0]
					self.buildPurifiers()
				},
				fnError: (error) => {
					console.warn(error)
				},
			}
		)

		this.content.getPage('products/?fields=*&', this.lang, {
			fnSuccess: (data: any) => {
				self.dataProduct = data.items
				self.buildPurifiers()
			},
			fnError: (error: any) => console.warn(error),
		})

		this.content.getPage('dictionary/?limit=9999&', this.lang, {
			fnSuccess: (data: any) => {
				data.items.map((item: any) => {
					if (item.key === 'resellerInputFullName') {
						this.inputName = item.value
					} else if (item.key === 'resellerInputEmail') {
						this.inputEmail = item.value
					} else if (item.key === 'resellerInputPhone') {
						this.inputPhone = item.value
					} else if (item.key === 'resellerInputCNPJ') {
						this.inputCnpj = item.value
					} else if (item.key === 'newsletterButton') {
						this.inputSend = item.value
					} else if (item.key === 'iceFormTitle') {
						this.iceFormTitle = item.value
					} else if (item.key === 'iceFormCep') {
						this.inputCep = item.value
					} else if (item.key === 'iceFormTerms') {
						this.inputTerms = item.value
					} else if (item.key === 'modalSuccessTitle') {
						this.modalSuccessTitle = item.value
					} else if (item.key === 'modalSuccessText') {
						this.modalSuccessText = item.value
					} else if (item.key === 'modalErrorTitle') {
						this.modalErrorTitle = item.value
					} else if (item.key === 'modalErrorText') {
						this.modalErrorText = item.value
					} else if (item.key === 'resellerModalButton') {
						this.resellerModalButton = item.value
					} else if (item.key === 'onlyNumbersPlaceHolder') {
						this.onlyNumbersPlaceHolder = item.value
					} else if (item.key === 'iceMachineProduction') {
						this.dictionary.production = item.value
					} else if (item.key === 'iceMachineSize') {
						this.dictionary.size = item.value
					} else if (item.key === 'iceMachineVoltage') {
						this.dictionary.voltage = item.value
					} else if (item.key === 'iceMachinePower') {
						this.dictionary.power = item.value
					} else if (item.key === 'iceMachineFrequency') {
						this.dictionary.frequency = item.value
					} else if (item.key === 'iceMachineStainlessSteel') {
						this.dictionary.stainlessSteel = item.value
					} else if (item.key === 'iceMachineRefrigerantGas') {
						this.dictionary.refrigerantGas = item.value
					}else if (item.key === 'iceMachineDimensions') {
						this.dictionary.dimensions = item.value
					}
				})
			},
			fnError: (error: any) => console.warn(error),
		})
	}

	buildPurifiers(): void {
		if (!this.data || !this.dataProduct) return

		const products = (this.data.purifiers_cards || [])
			.map((card: any) => this.dataProduct.find((product: any) => product.id === card.product?.id))
			.filter((product: any) => !!product)

		this.dataPurifiers = [
			{ title: this.data.purifiers_title, products },
		]
	}
}
